import Icon from "../Icon";
import { Tag } from "bbcode-to-react";
import * as React from "react";
class SvgTag extends Tag {
    toHTML() {
        return [
            `<svg
      preserveAspectRatio='xMidYMid meet'
      class='icon icon-${this.getContent()}'
    >
    <use xlink:href=#'${this.getContent()}'>
    </svg>`,
        ];
    }
    toReact() {
        return React.createElement(Icon, { name: this.getContent() });
    }
}
export default SvgTag;
